export default "__VITE_ASSET__QGdqcRhi__"